module.exports = __webpack_public_path__ + "img/16581280_L.71ea0f10.png";